import { reviewBodySchema } from "@redotech/redo-review-db-schema/review-body-schema";
import * as z from "zod/v4";

export const getReviewsByProductId = {
  name: "getReviewsByProductId" as const,
  input: z.object({ teamId: z.string(), productId: z.string() }),
  output: z.array(reviewBodySchema),
};
